import { HTMLAttributes } from 'react';
import { StyledTab } from './styled';

export interface TabProps extends HTMLAttributes<HTMLDivElement> {
  name: string;
  selected: boolean;
  disabled?: boolean;
}

export function Tab({
  name,
  selected,
  disabled,
  ...props
}: TabProps): JSX.Element {
  return (
    <StyledTab
      key={name}
      selected={selected}
      disabled={disabled ?? false}
      {...props}
    >
      {name}
    </StyledTab>
  );
}
